export const normalizeStage = (value: string | null | undefined): string =>
  (value ?? "").replace(/[\s_-]+/g, "").toLowerCase();
